import type {
  YardiInviteAddResetInput,
  YardiInviteAddResetResult,
} from '../types'

/**
 * Add Invite reset: clear prospect/result in the hook; restore role defaults when the user
 * had locked company/property pre-filled on load (listed + active). Admin / unlocked users get empty selects.
 */
export function buildYardiInviteAddResetState(
  input: YardiInviteAddResetInput,
): YardiInviteAddResetResult {
  const companyId = input.roleDefaultCompanyId?.trim() || ''
  const propertyId = input.roleDefaultPropertyId?.trim() || ''

  const companyOptions =
    companyId !== ''
      ? [{ value: companyId, label: input.roleDefaultCompanyName || companyId }]
      : []

  const propertyOptions =
    propertyId !== ''
      ? [{ value: propertyId, label: input.roleDefaultPropertyName || propertyId }]
      : []

  return {
    companyId,
    propertyId,
    companyOptions,
    propertyOptions,
  }
}
